import { SupportedPaymentMethods } from '../constants';

import {
  AffirmForm,
  BankForm,
  GenericCardForm,
  OxxoForm,
  PayPalForm,
  GooglePayForm,
} from './payment-methods';
import {
  CardMethodIcon,
  BankMethodIcon,
  PaypalMethodIcon,
  OxxoMethodIcon,
  AffirmMethodIcon,
  ApplePayMethodIcon,
  GooglePayMethodIcon,
} from './ui-elements/MethodIcon';

/**
 * Associates each payment method with its name, icon, and form rendered when
 * it's selected.
 *
 * General shape:
 * ```
 * {
 *   "payment-type": {
 *     title: "Payment Type Name",
 *     Component: PaymentTypeForm,
 *     Icon: PaymentTypeMethodIcon,
 *     hasAmount: false // optional
 *   }
 * }
 * ```
 */
export const PaymentMethodRegistry = {
  [SupportedPaymentMethods.CARD]: {
    /**  "title" is a translations key */
    title: 'paymentMethodCard',
    PaymentFormComponent: GenericCardForm,
    Icon: CardMethodIcon,
    hasAmount: undefined,
  },
  [SupportedPaymentMethods.PAYPAL]: {
    title: 'paymentMethodPaypal',
    PaymentFormComponent: PayPalForm,
    Icon: PaypalMethodIcon,
    hasAmount: true,
  },
  [SupportedPaymentMethods.BANK]: {
    title: 'paymentMethodBankTransfer',
    PaymentFormComponent: BankForm,
    Icon: BankMethodIcon,
    hasAmount: undefined,
  },
  [SupportedPaymentMethods.OXXO]: {
    title: 'paymentMethodOXXO',
    PaymentFormComponent: OxxoForm,
    Icon: OxxoMethodIcon,
    hasAmount: undefined,
  },
  [SupportedPaymentMethods.AFFIRM]: {
    title: 'paymentMethodAffirm',
    PaymentFormComponent: AffirmForm,
    Icon: AffirmMethodIcon,
    hasAmount: undefined,
  },
  [SupportedPaymentMethods.APPLEPAY]: {
    title: 'paymentMethodApplePay',
    PaymentFormComponent: GooglePayForm,
    Icon: ApplePayMethodIcon,
    hasAmount: true,
  },
  [SupportedPaymentMethods.GOOGLEPAY]: {
    title: 'paymentMethodGooglePay',
    PaymentFormComponent: GooglePayForm,
    Icon: GooglePayMethodIcon,
    hasAmount: true,
  },
};
